<button *ngIf="showButton" type="button" class="btn btn-danger grid-button" [disabled]="this.eventCompleted" (click)="toggleShift(obj, $event)">
  <i class="material-icons" >cancel</i>
</button>
<div *ngIf="!showButton"></div>
